import React from "react"
import Layout from "src/components/Layout"
import LinkedButton from "../components/buttons/LinkedButton"

export default function Volunteer() {
  return (
    <Layout>
      <div className="container">
        <h1 className="heading">Volunteer</h1>
        <div>
          If you want to contribute to our cause as a volunteer please fill up
          the form and we will get back to you.
          <br />
          <p>Thank you for being awesome</p>
          <LinkedButton
            path="https://docs.google.com/forms/d/e/1FAIpQLScJL4Sv_KHdCCYLnGHtch6HX_kh5iE6VbaRuAiQiwH7Gnp27Q/viewform"
            label="Join Us"
          />
        </div>


        <div>
            <h1 className="heading">Why Join Us?</h1>
            <p>
              At Project Nenathambara we are working towards bringing technology education 
              to all parts of Sri Lanka.
            </p> <br />
            
            <p>You shall be giving back to your own schools, village, city and community.
            </p><br />
              
            <p>
              You get to know other volunteers in Sri Lanka and abroad including academics and in the industry.
              
            </p><br />

            <p>Come!  Say <b>Hi</b> and join with us!
            </p><br />
        </div>
      </div>
    </Layout>
  )
}
